import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route, useLocation } from "react-router-dom";
import GlobalStyles from "./globalStyles";
import { Navbar, Footer } from "./components";
import Home from "./pages/HomePage/Home";
import ScrollToTop from "./components/ScrollToTop";
import NotFound from "./pages/NotFound/NotFound";
import NewsletterList from "./pages/Newsletter/NewsletterList";
import NewsletterPost from "./pages/Newsletter/NewsletterPost";
import Unsubscribe from "./pages/Unsubscribe/Unsubscribe";

function RecruitRedirect() {
  useEffect(() => {
    window.location.replace("https://recruiting.basakansoft.com");
  }, []);

  return null;
}

function LanguageRedirect() {
  const location = useLocation();
  
  useEffect(() => {
    // 현재 경로가 루트이고 언어 경로가 없는 경우에만 리다이렉트
    if (location.pathname === '/') {
      // 브라우저 언어 감지
      const browserLang = navigator.language || navigator.userLanguage;
      const isKorean = browserLang && (browserLang.startsWith('ko') || browserLang.includes('KR'));
      
      // 한국어가 아니면 /en으로, 한국어면 /ko로 리다이렉트
      const targetLang = isKorean ? 'ko' : 'en';
      window.location.replace(`/${targetLang}`);
    }
  }, [location.pathname]);
  
  return null;
}

function App() {
  return (
    <Router>
      <GlobalStyles />
      <ScrollToTop />
      <Navbar />
      <Switch>
        <Route path="/" exact component={LanguageRedirect} />
        <Route path="/:lang(ko|en)" exact component={Home} />
        <Route path="/:lang(ko|en)/newsletter" exact component={NewsletterList} />
        <Route
          path="/:lang(ko|en)/newsletter/category/:category"
          exact
          component={NewsletterList}
        />
        <Route path="/:lang(ko|en)/newsletter/:slug" exact component={NewsletterPost} />
        <Route path="/recruit" exact component={RecruitRedirect} />
        <Route path="/u/:token" exact component={Unsubscribe} />
        <Route path="/*" component={NotFound} />
      </Switch>
      <Footer />
    </Router>
  );
}

export default App;
